import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: "https://a23a06d0b7f6af8c7adec2c1c06c7bfd@o4508371432833024.ingest.us.sentry.io/4509157625692160"
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
